"use client";
import React, { useState } from 'react';
import { LogOut } from 'lucide-react';
import LogoutModal from './LogoutModal';

const LogoutButton = ({ isCollapsed }) => {
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  return (
    <>
      <button
        onClick={() => setShowLogoutModal(true)}
        className={`w-full flex items-center gap-3 px-3 py-3 text-gray-700 hover:bg-red-50 hover:text-red-600 rounded-xl transition-all duration-200 group ${
          isCollapsed ? 'justify-center' : ''
        }`}
        title={isCollapsed ? 'Sign Out' : ''}
      >
        <LogOut className="w-5 h-5 flex-shrink-0" />
        {!isCollapsed && <span className="font-medium">Sign Out</span>}

        {/* Tooltip for collapsed state */}
        {isCollapsed && (
          <div className="absolute left-full ml-2 px-3 py-2 bg-gray-800 text-white text-sm rounded-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200 whitespace-nowrap z-50">
            Sign Out
          </div>
        )}
      </button>

      {/* Logout Modal */}
      <LogoutModal
        isOpen={showLogoutModal}
        onClose={() => setShowLogoutModal(false)}
      />
    </>
  );
};

export default LogoutButton;
